/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
// require("prismjs/themes/prism.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
require("./styles/prism.css")